/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const IndicatorSeparator = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.IndicatorSeparator;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

IndicatorSeparator.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      IndicatorSeparator: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

IndicatorSeparator.defaultProps = {
  selectProps: {
    custom: {
      IndicatorSeparator: null,
    },
  },
  children: null,
};

export default IndicatorSeparator;
